import {
  take,
  call,
  put,
  select,
  fork,
  takeLatest,
  race,
  all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  GO_TO,
  FETCH_EHUB_AUTH_TOKEN,
  OPEN_EHUB_DISCLAIMER,
} from '../actions/ehubAction';
import { goto } from '../../../actions/historyActions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  getAuthToken,
  getCardViewState,
  getAuthTokenParamName,
} from '../selectors/ehubSelector';
import uuidv4 from 'uuid/v4';
import { getLanguage } from '../../../selectors/userSelectors';
import { openDisclaimer } from '../../emma-common/actions';
import { REDIRECT_ACTION } from '../../partners/actions';
import { PostMsgParams } from '../../partners/types/partnerTypes';

function* fetchEhubAuthToken(action: any) {
  const { url, fetchEHubAuthTokenSuccess, fetchEHubAuthTokenFailure } =
    action.payload;
  try {
    if (!url) {
      return;
    }

    const language = yield select(getLanguage);
    const languageUpperCase = language ? language.toUpperCase() : '';
    const urlWithParam = url.replace('${language}', languageUpperCase);
    const res = yield call(myAxaFetchWithToken, urlWithParam, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-axahk-msgid': uuidv4(),
      },
    });

    if (res && res.status === 200) {
      const data = yield res.json();
      const { retrieveEHubResponse } = data;
      if (retrieveEHubResponse) {
        const { authToken } = retrieveEHubResponse;
        yield put(fetchEHubAuthTokenSuccess(authToken));
      } else {
        throw res;
      }
    } else {
      throw res;
    }
  } catch (e) {
    yield put(fetchEHubAuthTokenFailure(e));
  }
}

function* goToRedirect(action: any) {
  if (action && action.payload) {
    const { url, cardViewId } = action.payload;
    const authToken = yield select(getAuthToken, cardViewId);
    const authTokenParamName = yield select(getAuthTokenParamName, cardViewId);

    const postMsgParams: PostMsgParams = {};
    postMsgParams.action = REDIRECT_ACTION;
    if (authToken && authTokenParamName) {
      postMsgParams.params = {};
      postMsgParams.params[authTokenParamName] = authToken;
    }
    yield call(goto, url, undefined, postMsgParams);
  }
}

function* openEHubDisclaimer(action: any) {
  if (action && action.payload) {
    const { disclaimerId, cardViewId } = action.payload;
    const authToken = yield select(getAuthToken, cardViewId);
    const authTokenParamName = yield select(getAuthTokenParamName, cardViewId);
    const postMsgParams: PostMsgParams = {};
    postMsgParams.action = REDIRECT_ACTION;
    if (authToken && authTokenParamName) {
      postMsgParams.params = {};
      postMsgParams.params[authTokenParamName] = authToken;
    }
    yield put(openDisclaimer(disclaimerId, postMsgParams));
  }
}

function* ehubSaga() {
  yield takeLatest(FETCH_EHUB_AUTH_TOKEN, fetchEhubAuthToken);
  yield takeLatest(GO_TO, goToRedirect);
  yield takeLatest(OPEN_EHUB_DISCLAIMER, openEHubDisclaimer);
}

export default ehubSaga;
